var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDiners = function SvgDiners(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 637 504",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1 -1H581V401H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "m372.69,504.00288c137.75,0.65612 263.48,-112.34388 263.48,-249.81288c0,-150.33 -125.73,-254.24 -263.48,-254.19002l-118.55,0c-139.4,-0.04998 -254.14,103.89102 -254.14,254.19002c0,137.499 114.74,250.47 254.14,249.81288l118.55,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m254.701,20.83c-127.38,0.04 -230.6,103.29 -230.63,230.721c0.03,127.409 103.249,230.649 230.63,230.689c127.41,-0.04 230.651,-103.28 230.669,-230.689c-0.019,-127.431 -103.259,-230.681 -230.669,-230.721zm-146.19,230.721l0,0c0.12,-62.27 39.01,-115.37 93.85,-136.471l0,272.91c-54.84,-21.089 -93.731,-74.16 -93.85,-136.439zm198.51,136.499l0,0l0,-272.979c54.86,21.05 93.81,74.18 93.91,136.48c-0.1,62.319 -39.05,115.409 -93.91,136.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "m372.69,504.00288c137.75,0.65612 263.48,-112.34388 263.48,-249.81288c0,-150.33 -125.73,-254.24 -263.48,-254.19002l-118.55,0c-139.4,-0.04998 -254.14,103.89102 -254.14,254.19002c0,137.499 114.74,250.47 254.14,249.81288l118.55,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m254.701,20.83c-127.38,0.04 -230.6,103.29 -230.63,230.721c0.03,127.409 103.249,230.649 230.63,230.689c127.41,-0.04 230.651,-103.28 230.669,-230.689c-0.019,-127.431 -103.259,-230.681 -230.669,-230.721zm-146.19,230.721l0,0c0.12,-62.27 39.01,-115.37 93.85,-136.471l0,272.91c-54.84,-21.089 -93.731,-74.16 -93.85,-136.439zm198.51,136.499l0,0l0,-272.979c54.86,21.05 93.81,74.18 93.91,136.48c-0.1,62.319 -39.05,115.409 -93.91,136.499z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diners.28da5ec7.svg";
export { ForwardRef as ReactComponent };